'use strict';

var GridToolbarRomSummaryTopRecapController = function GridToolbarRomSummaryTopRecapController() {};
GridToolbarRomSummaryTopRecapController.$inject = [];
module.exports = GridToolbarRomSummaryTopRecapController;